








































import _ from 'lodash';
import mixins from 'vue-typed-mixins';
import { mapActionsDvm } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';
import { PageMode } from '@/main/utils/pageMode';
import { store } from '@/modules/servis/zakazka/store/edit';

import { UserRole } from '@/main/components/constants';

import { Tabs, UzivatelskeNotifikace } from '../../components';
import NoveVozidloSelect from '../../components/microcomponents/NoveVozidloSelect.vue';
import EditLayout from '../../EditLayout.vue';
import { EditMixin } from '../../mixins/editMixin';
import InterniKarta from '../kulance/InterniKarta.vue';
import MicroPracovnikSelect from '../../components/microcomponents/PracovnikSelect.vue';
import WorkflowButtons from '../../components/WorkflowButtons.vue';
import PnvSelect from '../../components/microcomponents/PnvSelect.vue';
import { types } from '../../store/types';
import HlavniKarta from './HlavniKarta.vue';
import { NAME } from './constants';
import { MENU_CODE, TAB_NAMES, TABS } from '../../constants';

export default mixins(EditMixin).extend({
	name: editName(NAME),
	components: {
		MicroPracovnikSelect,
		NoveVozidloSelect,
		EditLayout,
		HlavniKarta,
		InterniKarta,
		PnvSelect,
		Tabs,
		UzivatelskeNotifikace,
		WorkflowButtons,
	},
	computed: {
		isUserServiceAdvisorOrCre(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.SERVICE_ADVISER) || this.pracovnik.PracovnikOzn === (UserRole.CRE);
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.AddvancePay)) tabItems.push(TAB_NAMES.ADVANCEPAY);
			if (this.hasTabAccess(MENU_CODE, TABS.Prac)) tabItems.push(TAB_NAMES.PRAC);
			if (this.hasTabAccess(MENU_CODE, TABS.CiziVykonySlevyKorekce)) tabItems.push(TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE);
			if (this.hasTabAccess(MENU_CODE, TABS.ZapujckyRef)) tabItems.push(TAB_NAMES.ZAPUJCKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Kalkulace)) tabItems.push(TAB_NAMES.KALKULACE);
			if (this.hasTabAccess(MENU_CODE, TABS.Zalohy)) tabItems.push(TAB_NAMES.ZALOHY);
			if (this.hasTabAccess(MENU_CODE, TABS.Vydejky)) tabItems.push(TAB_NAMES.VYDEJKY);
			if (this.hasTabAccess(MENU_CODE, TABS.History)) tabItems.push(TAB_NAMES.HISTORY);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(MENU_CODE, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(MENU_CODE, TABS.ZakazkyRef)) tabItems.push(TAB_NAMES.ZAKAZKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Reference)) tabItems.push(TAB_NAMES.REFERENCE);
			if (this.hasTabAccess(MENU_CODE, TABS.PlanSkutecnost)) tabItems.push(TAB_NAMES.PLAN_SKUTECNOST);
			if (this.hasTabAccess(MENU_CODE, TABS.Doklady)) tabItems.push(TAB_NAMES.DOKLAD);
			if (this.hasTabAccess(MENU_CODE, TABS.OSC)) tabItems.push(TAB_NAMES.ZAKAZKY_OSC);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers() {
			return {
				pnv: `${this.storeUri}/${types.mutations.ZAKAZKA_PNV_SELECT_MAPPER}`,
			};
		},
		actionsMapper() {
			return {
				pnvChange: `${this.storeUri}/${types.actions.ZAKAZKA_PNV_CHANGE}`,
			};
		},
		zakaznikExists() {
			return this.ZakaznikId! > 0;
		},
	},
	watch: {
		NvskladId(n, o) { // TP1/TODO: check jestli to funguje po refaktoru
			if (n && n !== o) this.$store.dispatch(`${this.storeUri}/${types.actions.LOAD_MDV_VOZIDLO}`);
		},
	},
	async mounted() {
		if (this.layoutProps.mode === PageMode.EDIT || this.layoutProps.mode === PageMode.CREATE) {
			(this.validationRules as { PnvId: { required: boolean } }).PnvId.required = true;
			(this.validationRules as { NvskladId: { required: boolean } }).NvskladId.required = true;
		}

		if (this.NvskladId) {
			await this.loadMdvVozidlo();
		}

		if (this.PnvId) {
			await this.loadMdvPnv();
		}
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
